<ng-container *notInPopulation="[populations.Pts, populations.Suite]">
  <div class="full-page-container">
    <fgb-banner [title]="'rewards.page.title' | translate"></fgb-banner>

    <div class="d-block d-lg-none">
      <fgb-page-header [pageTitle]="'rewards.page.title'" [backButtonLink]="'/'"></fgb-page-header>
    </div>

    <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

    <div class="container mt-4">
      <fgbcl-marketplace-list
        [isList]="true"
        [marketplaceItemView]="true"
        [marketplaceItemTypes]="[0, 1, 2]"
        [defaultSort]="0"
      ></fgbcl-marketplace-list>
    </div>
  </div>
</ng-container>

<ng-container *inPopulation="[populations.Pts, populations.Suite]">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
